import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import ConfirmScheduleJob from "../../../screens/VisitTimelineScreen/JobAction/ConfirmScheduleJob";

const HouseKeepingConfirmModal = ({ jobId, open, handleClose }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
          minWidth: "40vw", // Large width
          maxWidth: 1000, // Cap max width
          minHeight: "50vh",
          maxHeight: "90vh", // Cap max height
          overflowY: "auto", // Scrollable if content exceeds
        }}
      >
        <ConfirmScheduleJob JobId={jobId} handleClose={handleClose} />
      </Box>
    </Modal>
  );
};

export default HouseKeepingConfirmModal;
